export default {
  methods: {
    customFilter: config => {
      config.options.splice(0, 0, "empty");
      const filterOptions = config.options.map(val => {
        if (typeof val === "object") {
          return {
            displayKey: val.key,
            displayName: val.value,
            test: function(filterValue, cellValue) {
              return (
                cellValue.toString().toLowerCase() ===
                val.key.toString().toLowerCase()
              );
            },
            hideFilterInput: true
          };
        } else {
          if (val.toLowerCase() === "empty") return "empty";
          return {
            displayKey: val,
            displayName: val,
            test: function(filterValue, cellValue) {
              return cellValue.toLowerCase() === val.toLowerCase();
            },
            hideFilterInput: true
          };
        }
      });

      return {
        filterOptions: filterOptions,
        suppressAndOrCondition:
          config.suppressAndOrCondition === false ? false : true,
        closeOnApply: true,
        buttons: ["apply", "reset"]
      };
    },
    // Fits a grid to its rows, up to maxHeight, so short lists don't leave empty space.
    // The extra 20px covers the grid border and a horizontal scrollbar.
    gridHeight(
      rowCount,
      maxHeight,
      { rowHeight = 30, headerHeight = 30 } = {}
    ) {
      const rows = Math.max(rowCount || 0, 1);
      return `${Math.min(headerHeight + rows * rowHeight + 20, maxHeight)}px`;
    }
  }
};
